import { render, staticRenderFns } from "./CarouselNews.vue?vue&type=template&id=a3a8fe16&scoped=true"
import script from "./CarouselNews.vue?vue&type=script&lang=js"
export * from "./CarouselNews.vue?vue&type=script&lang=js"
import style0 from "./CarouselNews.vue?vue&type=style&index=0&id=a3a8fe16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a8fe16",
  null
  
)

export default component.exports